<template>
  <div>
    <!-- <header-nav></header-nav> -->
    <!-- <div
      class="home-page-header"
    >Welcome {{loginUserInfo && (loginUserInfo.name || loginUserInfo.userId)}}</div> -->
    <div class="container_bottom">
      <div class="img_dn">
        <img height="100%" src="../../assets/slt.png" />
      </div>
      <div class="home-page-section-list">
        <div class="home-page-section" @click="goto('/video-call')">
          <img height="100" src="../../assets/spth.png" />
          <div class="home-page-section-title">视频通话</div>
        </div>
        <!-- <div class="home-page-section" @click="goto('/audio-call')">
          <img height="100" src="../../assets/yyth.png" />
          <div class="home-page-section-title">语音通话</div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HeaderNav from "../header-nav";
export default {
  name: "HomePage",
  computed: mapState({
    loginUserInfo: (state) => state.loginUserInfo,
  }),
  data() {
    return {
      enableEditName: true,
      searchInput:""
    };
  },
  components: {
    HeaderNav
  },
  watch:{
     callStatus: function (newStatus, oldStatus) {
      // 作为被邀请者, 建立通话连接
      if (newStatus !== oldStatus && newStatus === "connected") {

        // this.$trtcCalling.on(this.TRTCCalling.EVENT.USER_ENTER, this.handleUserEnter);
      }
    },
  },
  mounted() {
  },
  computed: {
    ...mapState({
      loginUserInfo: (state) => state.loginUserInfo,
      meetingUserIdList: (state) => state.meetingUserIdList,
      callStatus: (state) => state.callStatus,
      isAccepted: (state) => state.isAccepted,
      isInviter: (state) => state.isInviter,
    })
  },
  methods: {
    handleCallUser: function () {
      this.callFlag = true;
      this.$trtcCalling
        .call({
          userID: this.searchInput,
          type: this.TrtcCalling.CALL_TYPE.VIDEO_CALL,
        })
        .then(() => {
          this.callFlag = false;
          this.$store.commit("userJoinMeeting", this.loginUserInfo.userId);
          this.$store.commit("updateCallStatus", "calling");
          this.$store.commit("updateIsInviter", true);
          // if(this.callStatus == "connected"){
            // this.$router.push('/video-call');

          // }
        }).catch(err=>{
          console.log(err)
          this.callFlag = false;
          this.$message({
            message: "请检查设备是否按插好",
            type: "error",
          });
        })
    },
    GetRequest(localUrl) {
      //url例⼦：XXX.aspx?ID=" + ID + "&Name=" + Name；
      var url = localUrl; //获取url中"?"符以及其后的字串
      var addressParameter = {};
      if (url.indexOf("?") != -1) {
        //url中存在问号，也就说有参数。
        var str;
        if (url.indexOf("=") != -1) {
          str = url.substr(1, url.indexOf("=") - 1);
        } else {
          str = url.substr(1);
        }
        //地址栏参数解密
        var addressUrl = decodeURIComponent(atob(str));
        var addressData = addressUrl.split("&");
        for (var i = 0; i < addressData.length; i++) {
          addressParameter[addressData[i].split("=")[0]] = unescape(
            addressData[i].split("=")[1]
          );
        }
      }
      return addressParameter;
    },
    goto: function () {
      this.$router.push('/video-call');
      // this.handleCallUser()
    },
  },
};
</script>

<style scoped>
.img_dn {
  height: 470px;
}
.home-page-section-title {
  font-size: 34px;
  font-weight: bold;
}
.home-page-section-list {
  height: 470px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
/* .home-page-container {
  height: 100%;
  overflow: hidden;
  background: url("../../assets/beijing.png") no-repeat;
  background-size: 100% 100%;
} */
.home-page-header {
  padding: 30px 0 10px;
  font-size: 24px;
}
.home-page-section {
  border-radius: 6px;
  color: #ffffff;
  width: 400px;
  height: 200px;
  margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border: 1px solid #ffffff;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
}
.home-page-section:hover {
  cursor: pointer;
}
.change-name {
  margin-left: 10px;
  text-decoration: underline;
  color: #5f6368;
  font-size: 16px;
  cursor: pointer;
}
.container_bottom {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  height: 100%;
  justify-content: space-around;
  align-items: center;
  padding-top: 10%;
}
@media screen and (max-width: 1400px) {
  .img_dn {
    height: 370px;
  }
  .container_bottom {
    width: 1200px !important;
  }
  .home-page-section-list {
    margin-top: 20px;
  }

  .home-page-section {
    width: 350px !important;
    height: 170px !important;
  }
}

@media screen and (max-width: 767px) {
  .img_dn {
    height: 370px;
  }
  .container_bottom {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-around;
  }
  .home-page-section-list {
    margin-top: 20px;
    height: 370px;
  }

  .home-page-section {
    width: 350px !important;
    height: 170px !important;
  }
}
</style>
